import React from 'react';

const TextHighlight = ({ children, className = '', highlightClassName = 'text-green', variant = 'underline', ...props }) => {
    const isUnderline = variant === 'underline';
    return (React.createElement("span", { className: [
            'inline-block relative',
            isUnderline ? 'pb-1' : 'px-4 py-2',
            className,
        ].join(' '), ...props },
        isUnderline ? (React.createElement("svg", { width: "229", height: "9", viewBox: "0 0 229 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: [
                'absolute bottom-0 left-0 w-full',
                highlightClassName,
            ].join(' ') },
            React.createElement("path", { vectorEffect: "non-scaling-stroke", d: "M1 8c10.4-1.6 21.8-1.4 32.5-2 18.3-1 36.7-1.8 55-3L115 1.5c4-.2 8.1-.6 12-.5 3.3.1-1.4.9-1.7 1L111.4 4c-8.3 1.2-16.8 2-25 3.3-1.9.3 3.7-.1 5.6-.2 6.7-.4 13.3-1 20-1.3 38.5-2.4 77.2-4 116-2.9", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))) : (React.createElement("svg", { viewBox: "0 0 367 186", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "none", className: [
                'absolute top-0 left-0 h-full w-full',
                highlightClassName,
            ].join(' ') },
            React.createElement("path", { vectorEffect: "non-scaling-stroke", d: "m156.698671 33.0929946c-69.0989671-3.7009241-146.99780274 19.3048205-146.698671 62.4155852 0 46.0114892 76.1997248 82.3205552 171.998293 80.4200812 95.798568-1.500375 174.297395-40.009991 174.997384-86.4215798.69999-46.011489-83.698749-86.02147951-187.597196-78.6196313", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: ".06em" }))),
        React.createElement("span", { className: "relative" }, children)));
};

export { TextHighlight };
//# sourceMappingURL=TextHighlight.js.map
